import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './occasionSelector.module.css';

const OccasionSelectorButton = ({ handleSelectButton, selectedButton }) => {
  const { t } = useTranslation();
  const types = [
    {
      value: 'BIRTHDAY',
      label: t('typeOccasions.BIRTHDAY'),
    },
    {
      value: 'ANNIVERSARY',
      label: t('typeOccasions.ANNIVERSARY'),
    },
    {
      value: 'ROMANTIC_DINNER',
      label: t('typeOccasions.ROMANTIC_DINNER'),
    },
    {
      value: 'BUSSINES_MEAL',
      label: t('typeOccasions.BUSSINES_MEAL'),
    },
    {
      value: 'SPECIAL_EVENT',
      label: t('typeOccasions.SPECIAL_EVENT'),
    },
  ];

  return (
    <>
      <div className='fw-semibold text-primary font-tiny mb-3'>{t('whatOccasion')}</div>

      {types.map((p, i) => (
        <button
          key={i}
          onClick={() => handleSelectButton(p.value)}
          className={`font-small fade-up ${styles.occasionButton} ${
            selectedButton === p.value ? styles.selected : null
          }`}
          type='button'
        >
          {p.label}
        </button>
      ))}
    </>
  );
};

export default OccasionSelectorButton;
